<template>
  <div class="card">
    <form
      id="items-services-form"
      data-abide
      novalidate
    >
      <div
        v-for="(itemService, index) in itemServicesData"
        :key="itemService.id"
        class="card-section hover"
      >
        <div
          class="title"
          :class="highlightDeleteChange(itemService.addendumLabel) || highlightNonDeleteChange(itemService.addendumLabel)"
        >
          {{ itemService.title }}
        </div>
        <div
          v-if="itemService.sectionDesc"
          class="description"
          :class="highlightDeleteChange(itemService.addendumLabel) || highlightNonDeleteChange(itemService.addendumLabel)"
        >
          <pre><p>{{ itemService.sectionDesc || '' }}</p></pre>
        </div>
        <table>
          <thead>
            <th class="number">
              #
            </th>
            <th style="padding-left: 0;">
              {{ $t('tender.section.descOfWork') }}
            </th>
            <th class="qty-text">
              {{ $t('tender.section.qty') }}
            </th>
            <th class="unit-text">
              {{ $t('tender.section.unit') }}
            </th>
            <th class="rate-text">
              {{ $t('tender.section.rate') }}
            </th>
            <th class="unit-text">
              {{ $t('tender.section.total') }}
            </th>
          </thead>
          <tbody>
            <template v-for="item in itemService.lineItems">
              <tr
                :key="item.itemNo"
                class="line-item-row"
                :class="highlightDeleteChange(itemService.addendumLabel, item.addendumLabel) || highlightNonDeleteChange(item.addendumLabel)"
              >
                <td class="number">
                  {{ item.itemNo }}
                </td>
                <td class="desc-of-work-text">
                  <pre class="none-x-scroll"><p class="no-margin-bottom">{{ item.itemDesc }}</p></pre>
                </td>
                <td>
                  <input
                    v-if="editView"
                    v-model="item.itemQty"
                    v-hkldinput
                    v-fusioninputcheck="{
                      type: 'decimal',
                      pattern: (val) => (Number(val) || 0) > 0,
                      required: !disabledDeletedItem(itemService.addendumLabel, item.addendumLabel) && (!itemService.forReference || item.itemQty)
                    }"
                    type="text"
                    autocomplete="off"
                    :disabled="disabledDeletedItem(itemService.addendumLabel, item.addendumLabel)"
                    @change="()=>updateRate(item, bidServiceData.bidItemRates[item.id])"
                  >
                  <p
                    v-else
                    class="plain view-field"
                  >
                    {{ new SafeNumber(item.itemQty).toSafeString() }}
                  </p>
                </td>
                <td class="unit-text">
                  {{ item.itemUnit }}
                </td>
                <td>
                  <input
                    v-if="editView"
                    v-model="bidServiceData.bidItemRates[item.id]"
                    v-hkldinput
                    v-fusioninputcheck="{
                      type: 'decimal',
                      required: !disabledDeletedItem(itemService.addendumLabel, item.addendumLabel) && (!itemService.forReference || bidServiceData.bidItemRates[item.id])
                    }"
                    type="text"
                    autocomplete="off"
                    :required="!itemService.forReference"
                    :disabled="disabledDeletedItem(itemService.addendumLabel, item.addendumLabel)"
                    @change="()=>updateRate(item, bidServiceData.bidItemRates[item.id])"
                  >
                  <p
                    v-else
                    class="plain view-field"
                  >
                    {{ !isNaN(bidServiceData.bidItemRates[item.id]) ? formatAmount(new SafeNumber(bidServiceData.bidItemRates[item.id]).toSafeString()) : 0 }}
                  </p>
                </td>
                <td class="unit-text total_font">
                  <div class="item_total_column">
                    {{ !isNaN(item.total) ? formatAmount(item.total) : item.total }}
                  </div>
                </td>
              </tr>
              <tr
                v-for="option in item.options"
                :key="option"
                :class="highlightDeleteChange(itemService.addendumLabel, item.addendumLabel, option.addendumLabel) || highlightNonDeleteChange(option.addendumLabel)"
              >
                <td />
                <td class="option-desc">
                  <pre class="none-x-scroll"><p>{{ option.optionDesc }}</p></pre>
                </td>
                <td />
                <td />
                <td>
                  <input
                    v-if="editView"
                    v-model="bidServiceData.bidItemRates[option.id]"
                    v-fusioninputcheck="{type: 'decimal', nullable: true}"
                    v-hkldinput
                    type="text"
                    autocomplete="off"
                    :disabled="disabledDeletedItem(itemService.addendumLabel, item.addendumLabel, option.addendumLabel)"
                    @focusout="updateRate(option, bidServiceData.bidItemRates[option.id])"
                  >
                  <p
                    v-else
                    class="plain view-field"
                  >
                    {{ formatAmount(new SafeNumber(bidServiceData.bidItemRates[option.id]).toSafeString()) }}
                  </p>
                </td>
                <td />
              </tr>
            </template>
            <tr style="text-align: right; height:85px;">
              <td
                class="total_panel total_font"
                colspan="6"
                style="vertical-align: middle; "
              >
                <div class="currency-summary">
                  <div class="currency-label">
                    {{ $t('tender.section.subtotal', [currencyCode]) }}
                  </div>
                  <div class="total_number">
                    {{ !isNaN(subTotals[index]) ? formatAmount(subTotals[index]) : subTotals[index] }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="shouldShowOthersSection"
        class="item-services-add-others"
        :class="{disabled: othersDisabled}"
      >
        <div class="row">
          <span
            class="title"
            :class="highlightAllowServiceAddOthers"
          >
            {{ $t('tender.section.others') }}
          </span>
          <DottedDropdown
            v-if="editView"
            id="item-services-add-others-dropdown"
          >
            <li>
              <a
                :disabled="othersDisabled"
                @click="addLine()"
              >
                {{ $t('action.addLine') }}
              </a>
            </li>
          </DottedDropdown>
        </div>
        <table v-if="otherItems.length">
          <thead>
            <th class="number">
              #
            </th>
            <th style="padding-left: 0;">
              {{ $t('tender.section.descOfWork') }}
            </th>
            <th class="qty-text">
              {{ $t('tender.section.qty') }}
            </th>
            <th class="unit-text">
              {{ $t('tender.section.unit') }}
            </th>
            <th class="qty-text">
              {{ $t('tender.section.rate') }}
            </th>
            <th class="unit-text">
              {{ $t('tender.section.total') }}
            </th>
          </thead>
          <tbody>
            <template v-for="(line, lineIndex) in otherItems">
              <tr
                :key="lineIndex"
                class="line-item-row"
              >
                <td class="number">
                  {{ lineIndex +1 }}
                </td>
                <td>
                  <textarea
                    v-if="editView"
                    :id="addId('line.desc', lineIndex)"
                    v-autosize
                    class="autosize desc-work"
                    type="text"
                    :disabled="othersDisabled"
                    :placeholder="$t('tender.section.description')"
                    :value="line.itemDesc"
                    :required="true"
                    @change="event=>onLineChange(lineIndex, 'itemDesc', event.target.value)"
                  />
                  <pre
                    v-else
                    class="none-x-scroll"
                  ><p class="no-margin-bottom">{{ line.itemDesc }} </p></pre>
                </td>
                <td style="width: 10%;">
                  <input
                    v-if="editView"
                    :id="addId('line.qty', lineIndex)"
                    class="qty-input"
                    type="text"
                    :disabled="othersDisabled"
                    :value="line.itemQty"
                    :required="true"
                    @change="event => onLineChange(lineIndex, 'itemQty', event.target.value)"
                  >
                  <p
                    v-else
                    class="plain view-field"
                  >
                    {{ new SafeNumber(line.itemQty).toSafeString() }}
                  </p>
                </td>
                <td
                  :id="addId('line.unit', lineIndex)"
                  class="unit-text"
                >
                  <HKLSelect
                    v-if="editView"
                    :value="line.itemUnit || undefined"
                    :options="unitHklOptions"
                    :disabled="othersDisabled"
                    :showSearch="true"
                    placeholder=""
                    @change="value => onLineChange(lineIndex, 'itemUnit', value || '')"
                  />
                  <span v-else>{{ line.itemUnit }}</span>
                </td>
                <td>
                  <input
                    v-if="editView"
                    :id="addId('line.rate', lineIndex)"
                    v-model="line.rate"
                    v-fusioninputcheck="{type: 'decimal', nullable: true}"
                    v-hkldinput
                    type="text"
                    :disabled="othersDisabled"
                    :required="true"
                    @change="event => onLineChange(lineIndex, 'rate', event.target.value)"
                  >
                  <p
                    v-else
                    class="plain view-field"
                  >
                    {{ line.rate ? formatAmount(line.rate) : 0 }}
                  </p>
                </td>
                <td class="unit-text total_font">
                  <div class="total-dot-menu">
                    <span>{{ formatAmount(line.total) }}</span>
                    <DottedDropdown
                      v-if="editView"
                      :id="addId('lineActions-dropdown', lineIndex)"
                    >
                      <li :key="addId('lineDeleteLine', lineIndex)">
                        <a
                          :id="addId('lineDeleteLine', lineIndex)"
                          :disabled="othersDisabled"
                          @click="deleteLine(lineIndex)"
                        >
                          {{ $t('action.deleteLine') }}
                        </a>
                        <a
                          :id="addId('lineAddLine', lineIndex)"
                          :disabled="othersDisabled"
                          @click="addLine(lineIndex)"
                        >
                          {{ $t('action.addLine') }}
                        </a>
                      </li>
                    </DottedDropdown>
                  </div>
                </td>
              </tr>
            </template>
            <tr class="item-services-add-others-subtotal">
              <td
                class="total_panel total_font"
                colspan="7"
                style="vertical-align: middle; "
              >
                <div class="currency-summary">
                  <div class="currency-label">
                    {{ $t('tender.section.subtotal', [currencyCode]) }}
                  </div>
                  <div class="total_number">
                    {{ formatAmount(bidServiceData.totalOfOthers) }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="isEngineer && !isEmpty(bidServiceData.otherItem.rate)">
        <div class="title">
          {{ $t('tender.section.others') }}
        </div>
        <table>
          <thead>
            <th class="number">
              #
            </th>
            <th style="padding-left: 0;">
              {{ $t('tender.section.descOfWork') }}
            </th>
            <th class="qty-text">
              {{ $t('tender.section.qty') }}
            </th>
            <th class="unit-text">
              {{ $t('tender.section.unit') }}
            </th>
            <th class="qty-text">
              {{ $t('tender.section.rate') }}
            </th>
            <th class="unit-text">
              {{ $t('tender.section.total') }}
            </th>
          </thead>
          <tbody>
            <tr class="line-item-row">
              <td class="number">
                1
              </td>
              <td>
                <textarea
                  v-if="editView"
                  v-model="bidServiceData.otherItem.desc"
                  v-fusioninputcheck="{
                    type: 'string', tip: $t('hint.inputTip.string'),
                    pattern: (val) => (val || '').trim().length > 0,
                    required: !!bidServiceData.otherItem.rate
                  }"
                  v-autosize
                  v-hkldinput
                  v-checkVisibility
                  type="text"
                  :class="{'plain-text': !editView}"
                  class="autosize"
                />
                <p
                  v-else
                  class="no-margin-bottom"
                >
                  {{ bidServiceData.otherItem.desc }}
                </p>
              </td>
              <td class="unit-text">
                1
              </td>
              <td class="unit-text">
                Lot
              </td>
              <td>
                <input
                  v-if="editView"
                  v-model="bidServiceData.otherItem.rate"
                  v-fusioninputcheck="{
                    type: 'decimal',
                    required: !!bidServiceData.otherItem.rate || (bidServiceData.otherItem.desc || '').trim().length > 0}"
                  v-hkldinput
                  type="text"
                  autocomplete="off"
                  @focusout="refreshBidServiceData()"
                >
                <p
                  v-else
                  class="plain view-field"
                >
                  {{ formatAmount(new SafeNumber(bidServiceData.otherItem.rate).toSafeString()) }}
                </p>
              </td>
              <td class="unit-text total_font">
                <div class="item_total_column">
                  {{ formatAmount(bidServiceData.otherItem.rate) }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template v-if="bidServiceData.discountValue > 0 && isEngineer">
        <hr style="margin-top:40px; margin-bottom:0; width:100%; max-width:100%;">

        <div class="total_panel total_font total_panel_currency currency-summary">
          <div class="currency-label">
            {{ $t('tender.section.totalBeforeDiscount') }}
          </div>
          <div class="total_number">
            {{ formatAmount(totalBeforeDiscount) }}
          </div>
        </div>
        <div
          id="bid-discount-panel"
          class="discount-panel total_panel total_panel_currency"
        >
          <div class="total_font currency-label">
            {{ $t('tender.section.discount') }}
          </div>
          <div class="qty-text">
            <input
              v-model="bidServiceData.discountValue"
              v-fusioninputcheck="{type: 'decimal', required: !!bidServiceData.discountValue}"
              v-hkldinput
              class="align-select"
              type="text"
              :readonly="!editView"
              :class="{'plain-box': !editView}"
              @focusout="refreshBidServiceData()"
            >
          </div>
          <div>
            <HKLSelect
              id="discount_type_list"
              style="min-width: 150px; width: 170px; max-width: 100%;"
              :value="bidServiceData.discountType || undefined"
              :options="discountTypeHklOptions"
              :showSearch="true"
              placeholder=""
              :disabled="!editView"
              @change="onDiscountTypeChange"
            />
          </div>
        </div>
      </template>

      <hr style="margin-top:40px; margin-bottom:0; width:100%; max-width:100%;">

      <div class="total_panel row align-middle">
        <div class="small-7 medium-7 large-7 column" />
        <div
          class="small-5 medium-5 large-5 column total_panel_currency currency-summary"
          style="padding-right: 0;"
        >
          <div
            class="total_font currency-label"
            style="color: #e69500;"
          >
            {{ $t('tender.section.totalAmount', [currencyCode]) }}
          </div>
          <div
            class="total_number"
            style="color: #e69500;"
          >
            {{ formatAmount(totalFeeAfterDiscount) }}
          </div>
        </div>
      </div>

      <div class="title">
        {{ $t('tender.section.remark') }}:
      </div>
      <div class="description">
        <textarea
          v-if="editView"
          v-model="bidServiceData.remark"
          v-hkldinput
          type="text"
          :class="{'plain-box': !editView}"
        />
        <pre v-else>
          <p>{{ bidServiceData.remark | isEmptyValue }}</p>
        </pre>
      </div>
    </form>
  </div>
</template>

<script>
import lodash from 'lodash'
import CurrencyFormatter from 'currency-formatter'
import { mapState, mapGetters } from 'vuex'
import DottedDropdown from '@/controls/DottedDropdown'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { addendumChangeType, discountTypes } from '@/utils/locale'
import { getHighlightAllowServiceAddOthers, getTotalAmount } from '@/utils/tenderUtils'
import { TENDER_UNITS } from '@/api/tenders/consts'
import { utils as formUtils } from '@/plugin/InputChange'
import { SafeNumber } from '@/utils/amountUtil'

function getDefaultData () {
  return {
    bidServiceData: {
      bidItemRates: {},
      bidItemQtys: {},
      discountType: '% OFF',
      discountValue: 0,
      otherItem: {
        rate: '',
        desc: '',
      },
      otherItems: [],
      remark: '',
      totalOfOthers: 0,
      totalFee: 0,
    },
    formUtils,
    units: TENDER_UNITS,
    defaultUnit: 'Lot',

    // Non-persistent values
    itemServicesData: [],
    totalOfOthers: 0,
    subTotals: [],
    discountTypes: discountTypes,
    SafeNumber,
  }
}

export default {
  name: 'ItemsServicesBid',
  components: {
    HKLSelect,
    DottedDropdown,
  },
  props: {
    itemServices: {
      type: Array,
      default: undefined,
    },
    bidService: {
      type: Object,
      default: undefined,
    },
    editView: {
      type: Boolean,
      default: true,
    },
  },
  data: getDefaultData,
  computed: {
    ...mapState('tenders', {
      sections (state) {
        return state.currentTender.service
      },
      addendumClassName (state) {
        return state.addendumClassName
      },
    }),
    ...mapGetters('tenders', [
      'isAddendum', 'currentTender', 'isRepresentative',
    ]),
    ...mapGetters('user', [
      'isEngineer',
    ]),
    allowServiceAddOthers () {
      return lodash.get(this.currentTender, 'general.allowServiceAddOthers') || false
    },
    otherItems () {
      return this.bidServiceData.otherItems || []
    },
    othersDisabled () {
      return !this.allowServiceAddOthers
    },
    showOthersForVendor () {
      return this.allowServiceAddOthers || (this.otherItems && this.otherItems.length)
    },
    showOthersForEngineer () {
      return this.isEngineer && this.allowServiceAddOthers && this.otherItems.length
    },
    highlightAllowServiceAddOthers () {
      return getHighlightAllowServiceAddOthers({
        isAddendum: this.isAddendum,
        currentTender: this.currentTender,
      })
    },
    shouldShowOthersSection () {
      return this.isEngineer ? this.showOthersForEngineer : this.showOthersForVendor
    },
    totalBeforeDiscount () {
      let amount
      const otherItemRate = Number(this.bidServiceData.otherItem.rate) || 0
      const multiOtherItemsRate = Number(this.bidServiceData.totalOfOthers) || 0
      const otherAmount = this.allowServiceAddOthers ? (otherItemRate + multiOtherItemsRate) : otherItemRate
      if (this.itemServicesData.some(service => service.forReference)) {
        const length = this.subTotals.length
        amount = this.subTotals.reduce((acc, cur, index) =>
          (Number(acc) || 0) + ((index === length - 1) ? 0 : (Number(cur) || 0)), 0) + Number(otherAmount)
      } else {
        amount = this.subTotals.reduce((acc, cur) => (Number(acc) || 0) + (Number(cur) || 0), 0) + Number(otherAmount)
      }
      return amount || 0
    },
    totalFeeAfterDiscount () {
      return getTotalAmount(this.bidServiceData, this.totalBeforeDiscount)
    },
    currencyCode () {
      return lodash.get(this.currentTender, 'general.purchaseRequisition.currencyCode')
    },
    unitHklOptions () {
      return this.units.map((value) => ({
        name: value,
        value,
      }))
    },
    discountTypeHklOptions () {
      return Object.values(this.discountTypes).map((value) => ({
        name: value,
        value,
      }))
    },
  },
  watch: {
    bidService () {
      this.bidServiceData = { ...this.bidServiceData, ...this.bidService }
      if (this.bidServiceData) {
        this.othersTotal()
      }
      this.refreshBidServiceData()
    },
    itemServices () {
      this.itemServicesData = this.itemServices
      this.refreshBidServiceData()
    },
    totalFeeAfterDiscount () {
      this.$emit('update:totalFee', this.totalFeeAfterDiscount)
      this.bidServiceData.totalFee = this.totalFeeAfterDiscount
    },
    'bidServiceData.discountType': 'refreshBidServiceData',
  },
  methods: {
    reset (keep) {
      const def = getDefaultData()
      def[keep] = this[keep]
      Object.assign(this.$data, def)
    },
    formatAmount (amount) {
      return CurrencyFormatter.format(amount, 'USD')
    },
    addId (name, index) {
      return `${name}-${index}`
    },
    deleteLine (lineIndex) {
      const lineItems = this.bidServiceData.otherItems
      if (lineIndex > -1) {
        lineItems.splice(lineIndex, 1)
      }
      this.bidServiceData.otherItems = lineItems
      this.othersTotal()
      this.refreshBidServiceData()
    },

    addLine (lineIndex) {
      const lineItems = this.bidServiceData.otherItems
      const lineItem = this.initLineItem(lineIndex + 2)

      lineItems.splice(lineIndex + 1, 0, lineItem)
      this.bidServiceData.otherItems = lineItems
    },

    onDiscountTypeChange (value) {
      this.bidServiceData.discountType = value || ''
      formUtils.setDirty()
    },
    onLineChange (lineIndex, attr, newValue) {
      const value = newValue.trim()
      let item = this.bidServiceData.otherItems[lineIndex]
      if (item) {
        item[attr] = value
      }
      this.refreshOthers(lineIndex)
    },
    refreshOthers (lineIndex) {
      const value = this.bidServiceData.otherItems[lineIndex]
      const formatedRate = Number(value.rate) || 0
      const formatedQty = Number(value.itemQty) || 0

      const total = formatedQty * formatedRate
      value.total = total
      this.othersTotal()
    },

    othersTotal () {
      if (!!this.bidServiceData.otherItems && this.bidServiceData.otherItems.length) {
        this.bidServiceData.totalOfOthers = this.bidServiceData.otherItems.map((item) => {
          return item.total
        }).reduce((x, y) => {
          const totalSafeNumber = new SafeNumber(x).addBy(new SafeNumber(y))
          return this.editView ? totalSafeNumber.toSafeNumber() : totalSafeNumber.toSafeString()
        })
      } else {
        this.bidServiceData.totalOfOthers = 0
      }
    },

    initLineItem () {
      const emptyLine = {}
      emptyLine.itemDesc = ''
      emptyLine.itemQty = null
      emptyLine.itemUnit = this.defaultUnit
      emptyLine.rate = ''
      emptyLine.total = 0
      return emptyLine
    },

    refreshItemTotal () {
      this.itemServicesData.forEach((itemService, index) => {
        this.subTotals[index] =
          itemService.lineItems.map((rec) => {
            const qty = this.bidServiceData.bidItemQtys[rec.id]
            if (typeof qty !== 'undefined') {
              rec.itemQty = this.bidServiceData.bidItemQtys[rec.id]
            }
            const totalSafeNumber = (new SafeNumber(rec.itemQty)).multiplyBy(new SafeNumber(this.bidServiceData.bidItemRates[rec.id]))
            rec.total = this.editView ? totalSafeNumber.toSafeNumber() : totalSafeNumber.toSafeString()
            return (rec.addendumLabel === addendumChangeType.removed || itemService.addendumLabel === addendumChangeType.removed) ? 0 : rec.total
          }).reduce((x, y) => {
            const totalSafeNumber = new SafeNumber(x).addBy(new SafeNumber(y))
            return this.editView ? totalSafeNumber.toSafeNumber() : totalSafeNumber.toSafeString()
          }, '')
      })
    },
    refreshBidServiceData () {
      // Refresh itemServices value so as to re-render line items values
      this.othersTotal()
      this.refreshItemTotal()
      let tmp = this.itemServicesData
      this.itemServicesData = null
      this.itemServicesData = tmp
      tmp = this.subTotals
      this.subTotals = null
      this.subTotals = tmp
    },
    emitBidServiceDate () {
      // Sync bidItems value with parent component
      this.$emit('update:bidService', this.bidServiceData)
    },
    updateRate (item, rate) {
      this.bidServiceData.bidItemRates[item.id] = rate
      this.bidServiceData.bidItemQtys[item.id] = item.itemQty
      const formatedRate = Number(rate) || 0
      const formatedQty = Number(item.itemQty) || 0

      const total = formatedQty * formatedRate
      this.$set(item, 'total', total || 0)

      this.refreshBidServiceData()
    },
    validate () {
      this.form = $('#items-services-form')
      this.form.on('submit', (ev) => {
        ev.preventDefault()
      })
      this.abide = new Foundation.Abide(this.form, {
        liveValidate: false,
      })
      this.abide.validateForm()
      return $('#items-services-form input.is-invalid-input').length !== 0 ||
        $('#items-services-form textarea.is-invalid-input').length !== 0
    },
    clearErrorClasses () {
      if ($('#items-services-form .is-invalid-input').length > 0 && this.abide) {
        this.abide.removeErrorClasses($('#items-services-form .is-invalid-input'))
      }
    },
    highlightDeleteChange (...updatedLabels) {
      if (!this.isAddendum) return ''
      const matched = updatedLabels.filter(label => label === addendumChangeType.removed)
      return matched.length > 0 ? `${this.addendumClassName}-${addendumChangeType.removed}` : ''
    },
    highlightNonDeleteChange (updatedLabel) {
      if (!this.isAddendum || updatedLabel === addendumChangeType.removed) return ''
      return updatedLabel ? `${this.addendumClassName}-${updatedLabel}` : ''
    },
    disabledDeletedItem (...updatedLabels) {
      if (!this.isAddendum) return false
      let disabled = false
      updatedLabels.forEach((updatedLabel) => {
        if (updatedLabel === addendumChangeType.removed) {
          disabled = true
        }
      })
      return disabled
    },
    isEmpty (val) {
      return typeof val === 'undefined' || (typeof val === 'string' && val.length === 0)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings';
@import '~styles/tender/edit';
@import '~styles/tender/itemServices';
@import '~styles/tender/addendum';
$grey-color: #e0e0e0;

p {
  margin-bottom: 2px;
}

tbody td {
  padding: 0.2rem 0;
}

.line-item-row {
  border-top: solid 1px $grey-color;
  td {
    padding: 5px 0;
  }
  input[type='text'] {
    margin-bottom: 0;
  }
}

th {
  padding: 1.0rem 0 .9rem 0;
}

tr:nth-child(odd) {
  background: #f9f9f9;
  }
tr:nth-child(even) {
  background: #ffffff;
  }

.number {
  min-width: 30px;
}

.desc-of-work-text,
.option-desc {
  padding-right: 1vw;
}

.qty-text {
  min-width: 90px;
}

.align-select {
  height: 40px;
  margin-bottom:0;
}

.rate-text {
  text-align: center;
  width: 8%;
  min-width:105px;
}

.row {
  width: 100%;
  max-width: 100%;
}

.total_font {
  font-weight: bold;
  line-height: 1.43;
}

.total_number {
  font-family: Verdana;
  font-weight: normal;
  font-size: 24px;
  padding-top: 0.25rem;
}

.discount-panel {
  display: inline-flex;
}

.discount-panel span, .discount-panel input, .discount-panel multi-select {
  vertical-align: middle;
}

.currency-label {
  height: 44px;
  line-height: 44px;
  white-space: nowrap;
  margin-right: 11px;
  margin-left: auto;
}

.discount-panel td {
  vertical-align: middle;
}

input[type='text'] {
  margin-bottom: 0;
}

.total_panel{
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-right: 15px;
}

.item_total_column {
  min-width: 100px;
  padding-right: 15px;
  padding-left: 15px;
}
.item_total_with_dropdown {
  min-width: 65px;
  padding-left: 15px;

}

.description textarea {
  margin-top: 15px;
  width: 100%;
  height: 120px;
  font-family: Verdana;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #0C3A58;
}

.total_panel_currency {
  width: 100%;
  text-align: right;
}
.currency-summary {
  display: inline-flex;
}

input.is-invalid-input {
  background-color: #f9ecea!important;
}

.plain, .plain-text {
  border:none;
  border-color: transparent;
  background-color:transparent;
  box-shadow: none;
  margin-bottom: 0;
}
.plain {
  text-align: center;
  width: auto;
}
.plain-text {
  text-align: left;
}
.plain-box {
  border: 1px solid;
  border-color: grey;
  background-color:transparent;
  box-shadow: none;
  text-align: center;
  margin-bottom: 0;
}
textarea {
  margin-bottom: 0;
  overflow: auto;
}

.no-margin-bottom {
  margin-bottom: 0;
}

.none-x-scroll {
  -ms-overflow-x: hidden;
  overflow-x: hidden;
}

.view-field {
  line-height: 40px
}

.input, textarea {
  font-size: 14px;
  border: solid 1px #B5B5B5;
}

textarea[disabled], input[disabled] {
  border: solid 1px #e5e5e5;
  background: transparent;
}

.item-services-add-others.disabled {
  .row .title,
  .line-item-row,
  .line-item-row textarea,
  .line-item-row input,
  .currency-summary,
  td,
  td span
  {
    text-decoration: line-through;
    color: #e69500;
  }
  a {
    background: transparent;
    text-decoration: line-through;
    border-bottom: 2px solid transparent;
  }
}

.item-services-add-others-subtotal {
  text-align: right;
  height: 85px;
}

.total-dot-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
}

</style>

<style lang="scss">
#bid-discount-panel .multiselect__tags{
  padding: 0;
}

#bid-discount-panel .multiselect__single, #bid-discount-panel .multiselect__input, #bid-discount-panel .multiselect__tags {
  border: none;
}
</style>
